import React from "react";
import "./checkout.css";
import CheckoutProduct from "./CheckoutProduct";
import { useStateValue } from "./StateProvider";
import Subtotal from "./Subtotal";

function Checkout(image) {
  const [{ basket }, dispatch] = useStateValue();
  return (
    <div className="checkout">
      <div className="checkout_left">
        <img
          src="https://icms-image.slatic.net/images/ims-web/20d5c0e1-c877-460c-9185-0102b366dea5.jpg_1200x1200.jpg"
          alt=""
          className="checkout_ad"
        />

        <div className="">
          <h2 className="checkout_title">Your Shopping Basket</h2>


          {basket.map((item) => (
            <CheckoutProduct
            id = {item.id}
            title = {item.title}
            image = {item.image}
            price = {item.price}
            rating = {item.rating}
            />
          ))}

          {/* This if for test. It is static data for above basket*/}
          {/* <CheckoutProduct
            id="12345"
            title="This a test Cillum proident exercitation ullamco eiusmod do cillum veniam ex id proident eu."
            image="https://images-na.ssl-images-amazon.com/images/I/61T3GCJfygL._AC_UL160_SR160,160_.jpg"
            price="129.99"
            rating={5}
          />
          <CheckoutProduct
            id="12345"
            title="This a test Cillum proident exercitation ullamco eiusmod do cillum veniam ex id proident eu"
            image="https://images-na.ssl-images-amazon.com/images/I/61T3GCJfygL._AC_UL160_SR160,160_.jpg"
            price="129.99"
            rating={5}
          /> */}
        </div>
      </div>
      <div className="checkout_right">
        <Subtotal />
      </div>
    </div>
  );
}

export default Checkout;
